var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.value,attrs:{"data-qa":"value"}},[(_vm.raw)?_c('div',{class:_vm.$style.html,domProps:{"innerHTML":_vm._s(_vm.computedValue)}}):[_vm._v(_vm._s(_vm.computedValue))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }